export const GoogleMapsPluginID = 'googlemaps';
